import Vue from 'vue'
import router from '@/router'
import localStorageHelpers from './localStorage'

const LOCALE = 'ru'
function __request(method, url, data, hasToken, headers = {}, onResolve, onReject) {
  const qs = require('qs')

  let requestParams = {}

  if (method === 'PUT' || method === 'POST' || method === 'PATCH') {
    requestParams = {
      url: url,
      method: method,
      emulateJSON: true,
      data: data?.params || data,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false })
      },
      headers: {
        ...headers,
        'X-Requested-With': 'XMLHttpRequest',
        'X-Locale': navigator.language.substr(0, 2),
      },
      ..._.omit(data, ['params']),
    }
  } else {
    requestParams = {
      url: url,
      method: method,
      emulateJSON: true,
      paramsSerializer: function (params) {
        return qs.stringify(params, { encode: false })
      },
      headers: {
        ...headers,
        'X-Requested-With': 'XMLHttpRequest',
        'X-Locale': navigator.language.substr(0, 2),
      },
      ...data,
    }
  }

  const token = localStorage.getItem('token')
  if (hasToken) {
    requestParams.headers.Authorization = token
  }

  axios(requestParams).then(
    response => {
      onResolve(response)
    },
    response => {
      if (!requestParams.disableNotifications) {
        if ('message' in response && response.message === 'Network Error') {
          Vue.notify({
            title: '',
            type: 'error',
            text: Vue.config.localization[LOCALE].errors.networkError,
          })
          return
        }

        _.each(Vue.config.errors, (item, key) => {
          if (response.response?.data?.code === item) {
            Vue.notify({
              title: '',
              type: 'error',
              text: Vue.config.localization[LOCALE].errors[key],
            })
          }
        })
      }
      if (response.response?.data?.code === Vue.config.errors.tokenExpiredException) {
        axios({
          url: `${Vue.config.server}/${Vue.config.modules.crm.api.refresh}`,
          method: 'POST',
          emulateJSON: true,
          headers: {
            Authorization: token,
            'X-Requested-With': 'XMLHttpRequest',
          },
        }).then(
          response => {
            if (response.data?.result === 'success') {
              localStorageHelpers.__setToken(response.data?.data?.token)
              return __request(method, url, data, true, onResolve, onReject)
            }
          },
          response => {
            if (response.response?.data?.code === Vue.config.errors.tokenExpiredException) {
              router.push({ path: Vue.config.modules.crm.route.auth })
            }
          },
        )
      } else {
        onReject(response)
      }
    },
  )
}

function request(method, url, data, hasToken, headers) {
  return new Promise((resolve, reject) => {
    __request(
      method,
      url,
      data,
      hasToken,
      headers,
      response => {
        resolve(response)
      },
      response => {
        reject(response)
      },
    )
  })
}

export default request
